import { render, staticRenderFns } from "./top-theme.vue?vue&type=template&id=7084f537&scoped=true"
import script from "./top-theme.vue?vue&type=script&lang=js"
export * from "./top-theme.vue?vue&type=script&lang=js"
import style0 from "./top-theme.vue?vue&type=style&index=0&id=7084f537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7084f537",
  null
  
)

export default component.exports